const routes = [
  {
    path: '/search',
    name: 'CourseList',
    component: () => import('./pages/CourseList.vue'),
    meta: {
      title: 'Все курсы',
    },
  },
  {
    path: '/:id/view',
    name: 'CourseView',
    component: () => import('@/modules/CourseManagement/pages/Constructor.vue'),
    meta: {
      title: 'Курс',
      readonly: true,
      layout: 'empty-layout',
    },
  },
  {
    path: '/exchange/my-courses',
    name: 'ExchangeMyCourses',
    component: () => import('./pages/Exchange/MyCourses.vue'),
    meta: {
      title: 'Мои курсы на бирже',
    },
  },
  {
    path: '/exchange/requests',
    name: 'ExchangeRequests',
    component: () => import('./pages/Exchange/CoursesRequests.vue'),
    meta: {
      title: 'Заявки по курсам',
      breadcrumbs: {
        parent: 'ExchangeMyCourses',
      },
    },
  },
  {
    path: '/exchange/search',
    name: 'ExchangeSearchCourses',
    component: () => import('./pages/Exchange/SearchCourses.vue'),
    meta: {
      title: 'Поиск курсов',
    },
  },
  {
    path: '/exchange/:id',
    name: 'CourseDetails',
    component: () => import('./pages/Exchange/CourseDetails.vue'),
    meta: {
      title: 'Поиск курсов',
    },
  },
  {
    path: '/exchange/:id/send-request',
    name: 'NewCourseRequest',
    component: () => import('./pages/Exchange/NewCourseRequest.vue'),
    meta: {
      title: 'Заявка на покупку курса',
    },
  },
];

export default routes;
